const r = String.raw;

// Matches a single emoji:
//
// - A character with emoji presentation by default (`\p{Emoji_Presentation}`)
// - An astral pictograph
// - A character explicitly qualified with the emoji variation selector U+FE0F
//
// Each can be followed by a skin tone modifier, tag sequence, or keycap. Keycaps are
// handled separately so `#`, `*` and digits only match as part of a full keycap sequence
// and not on their own.
const base = r`(?:[#*\d]\uFE0F?\u20E3|(?:\p{Emoji_Presentation}|(?=[\u{1F000}-\u{1FFFF}])\p{Emoji}|(?![#*\d])\p{Emoji}\uFE0F)(?:\p{Emoji_Modifier}|[\u{E0020}-\u{E007E}]+\u{E007F}|\uFE0F?\u20E3?))`;

// Stateful regex (global flag) — do not use directly with .test() or .exec() as they
// advance lastIndex. All access should go through EmojiRegex.removeEmojis().
const EMOJI_REGEX = new RegExp(r`\p{Regional_Indicator}{2}|${base}(?:\u200D${base})*`, "gu");

/** Removes recognized emoji sequences from text while retaining standalone digits and punctuation. */
export class EmojiRegex {
  /**
   * Remove all emoji from a string.
   *
   * @param str The text from which to remove emoji.
   * @returns The string with matched emoji removed.
   */
  public static removeEmojis(str: string): string {
    return str.replace(EMOJI_REGEX, "");
  }
}
